import React, { useContext } from "react";
import emailjs from '@emailjs/browser';
import bsStyles from "./becomesupplier.module.css";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Button from "../../components/common/button";
import { LanguageContext } from "../../context/LanguageContext";

function BeacomeSupplier() {
  const { data } = useContext(LanguageContext);

  const SignupSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    country: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    growerName: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    businessName: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    contact: Yup.string()
      .required("Required"),
    product: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    exporter: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    additionalDetails: Yup.string()
  });

  const sendMail = async (descriptor) => {

    const templateParams = {
      name: descriptor.name,
      message: `Become a supplier - Details - Name - ${descriptor.name} ,  Email - ${descriptor.email} , Country - ${descriptor.country} , Grower - ${descriptor.growerName} , Business - ${descriptor.businessName} , Contact - ${descriptor.contact} , Product - ${descriptor.product} , Exporter - ${descriptor.exporter}, Additional Info - ${descriptor.additionalInfo}`
    };

  emailjs.send('service_yfg6w9i','template_308db6c', templateParams, 'pmvGrSwohM8dq_8Lo')
    .then((response) => {
        alert('Your message has been sent successfully');
    }, (err) => {
      alert('Something went wrong, please try again later');
       console.log('FAILED...', err);
    });
  }

  return (
    <div className="mainWrap">
      <div>
        <h5 className={` ${bsStyles.mainHeading} mainHeading`}>
          {data.supplierForm.title}
        </h5>
      </div>
      <div className={bsStyles.bsMainWrap}>
        <h5 className={` ${bsStyles.subheading} subHeading`}>
          {data.supplierForm.subtitle}
        </h5>

        <div className={bsStyles.becomeSupplierWrap}>
          <Formik
            initialValues={{
              name: "",
              email: "",
              country: "",
              growerName: "",
              businessName: "",
              contact: "",
              product: "",
              exporter: "",
              additionalDetails: "",
            }}
            validationSchema={SignupSchema}
            onSubmit={sendMail}
          >
            {({ errors, touched }) => (
              <Form>
                <div className={bsStyles.bsFormWrap}>
                  <div className={bsStyles.bsInputWrap}>
                    <div className={bsStyles.bsForm}>
                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="name">
                          {data.supplierForm.formLabels[0]}
                        </label>
                        <Field name="name" placeholder="John Doe" />
                        {errors.name && touched.name ? (
                          <div className="error">{errors.name}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="email">
                          {data.supplierForm.formLabels[2]}
                        </label>
                        <Field name="email" placeholder="Johndoe@gmail.com" />
                        {errors.email && touched.email ? (
                          <div className="error">{errors.email}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="country">
                          {data.supplierForm.formLabels[4]}
                        </label>
                        <Field name="country" placeholder="Russia" />
                        {errors.country && touched.country ? (
                          <div className="error">{errors.country}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="growerName">
                          {data.supplierForm.formLabels[6]}
                        </label>
                        <Field name="growerName" placeholder="John Doe" />
                        {errors.growerName && touched.growerName ? (
                          <div className="error">{errors.growerName}</div>
                        ) : null}
                      </div>
                    </div>

                    <div className={bsStyles.bsForm}>
                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="businessName">
                          {data.supplierForm.formLabels[1]}
                        </label>
                        <Field
                          name="businessName"
                          placeholder="Washington Fresh Fruits"
                        />
                        {errors.businessName && touched.businessName ? (
                          <div className="error">{errors.businessName}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="contact">
                          {data.supplierForm.formLabels[3]}
                        </label>
                        <Field name="contact" placeholder="Contact Number" />
                        {errors.contact && touched.contact ? (
                          <div className="error">{errors.contact}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="product">
                          {data.supplierForm.formLabels[5]}
                        </label>
                        <Field name="product" placeholder="Citrus Fruits" />
                        {errors.product && touched.product ? (
                          <div className="error">{errors.product}</div>
                        ) : null}
                      </div>

                      <div className={`inputWrap ${bsStyles.inputWrap}`}>
                        <label htmlFor="exporter">
                          {data.supplierForm.formLabels[7]}
                        </label>
                        <Field name="exporter" placeholder="David" />
                        {errors.exporter && touched.exporter ? (
                          <div className="error">{errors.exporter}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className={bsStyles.buttonWrap}>
                    <div className={`inputWrap ${bsStyles.inputWrap}`}>
                      <label htmlFor="additionalDetails">
                        {data.supplierForm.formLabels[8]}
                      </label>
                      <Field
                        name="additionalDetails"
                        type="text"
                        as="textarea"
                        placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget pulvinar justo, nec hendrerit nunc. Suspendisse a elit porttitor, sodales justo ac, convallis dolor."
                      />
                    </div>

                    <Button
                      type="submit"
                      name={data.supplierForm.btnLabel}
                      className={bsStyles.buttonWrap}
                      // onClick={sendMail}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default BeacomeSupplier;
